// eslint-disable-next-line import/no-cycle
import moment from 'moment-timezone';
// eslint-disable-next-line import/no-cycle
import { getProduct } from '../utils/db';
// eslint-disable-next-line import/no-cycle
import { addProduct, updateProduct } from '../utils/utils';
// eslint-disable-next-line import/no-cycle
// import { getUser, SERVER_TIMEZONE } from '../common/globals';

export const findProduct = async (scanner, products, allProduct) => {
  const barcode = scanner.data;
  const prefix = barcode.substring(0, 2);
  let type = '';
  let expiryDate = null;

  if (prefix === '01' && barcode.length > 20) {
    type = 'GS1 2D';
    let productData = {};
    let productBarcode = barcode.substr(0, 16);
    let lotBarcode = barcode.substr(16);
    if (barcode.length > 38 && barcode.substr(16, 2) === '20' && barcode.substr(20, 2) === '17'
      && barcode.substr(28, 2) === '11' && barcode.substr(36, 2) === '10') {
      lotBarcode = barcode.substr(20);
      // product = barcode.substr(0, 20);
    } else if (barcode.length > 34 && barcode.substr(16, 2) === '17' && barcode.substr(24, 2) === '11'
      && barcode.substr(32, 2) === '10') {
      lotBarcode = barcode.substr(16);
      // product = barcode.substr(0, 17);
    } else if (barcode.length > 20 && barcode.substr(16, 2) === '20') {
      lotBarcode = barcode.substr(20);
      // product = barcode.substr(0, 20);
    }
    productData = Object.assign(products, {
      ProductBarcode: productBarcode,
      LotBarcode: lotBarcode
    });
    productBarcode = productBarcode.substr(2, 14);
    const productMasterRes = await getProduct('GS1Barcode', productBarcode);
    if (!Object.keys(productMasterRes).length > 0) {
      // this.productExtractFailed(record, type);
    } else {
      productData = Object.assign(products, {
        BarcodeType: type,
        ProductNo: productMasterRes.ProductNo,
        ProductDescription: productMasterRes.ProductDescription,
        ProductBarcode: productMasterRes.GS1Barcode,
        ProductValid: true,
        ProductEnterType: 'SCAN',
        ScanType: 'product'
      });
    }
    // Find Lot
    const lotData = {
      key: scanner.key,
      data: lotBarcode
    };
    const lotScanRes = await findLot(lotData, products, allProduct);
    productData = Object.assign(productData, {
      LotNo: lotScanRes.LotNo,
      LotEnterType: lotScanRes.LotEnterType,
      LotBarcode: lotScanRes.LotBarcode,
      ExpirationDate: lotScanRes.ExpirationDate,
      ExpDateEnterType: 'SCAN',
      ScanType: 'product'
    });
    // this.extractLotFromBarcode(record, lotbarcode);
    return productData;
  }

  if (prefix === '01' && barcode.length <= 20) {
    type = 'GS1 1D';
    let productData = {};
    let productBarcode = barcode.substr(0, 16);
    if (barcode.length === 20 && barcode.substr(16, 2) === '20') {
      productBarcode = barcode;
    }
    productData = Object.assign(productData, {
      ProductBarcode: productBarcode,
    });
    productBarcode = productBarcode.substr(2, 14);
    const productMasterRes = await getProduct('GS1Barcode', productBarcode);
    if (!Object.keys(productMasterRes).length > 0) {
      // this.productExtractFailed(record, type);
    } else {
      productData = Object.assign(productData, {
        BarcodeType: type,
        ProductNo: productMasterRes.ProductNo,
        ProductDescription: productMasterRes.ProductDescription,
        ProductBarcode: barcode,
        ProductValid: true,
        ProductEnterType: 'SCAN',
        ScanType: 'product'
      });
    }
    // this.scanType = 'LOT';
    // this.getScanToolbar().down('#scannerSkipLotButton').setDisabled(this.scanType != 'LOT');
    return productData;
  }

  if ((prefix === '+B' || prefix === '+E' || prefix === '+H' || prefix === '+M') && barcode.length > 20) {
    type = 'HBIC 2D';
    let productData = {};
    if (barcode.indexOf('/') !== -1) {
      const arr = barcode.split('/');
      let productBarcode = arr[0];
      productData = Object.assign(productData, {
        ProductBarcode: productBarcode
      });

      productBarcode = productBarcode.substr(5);
      const splitLotBarcode = barcode.split('/');
      expiryDate = splitLotBarcode[1].substr(4, 6);
      let productMasterRes = await getProduct('ProductNo', productBarcode);

      if (!Object.keys(productMasterRes).length > 0) {
        productBarcode = productBarcode.substr(0, productBarcode.length - 1);
        productMasterRes = await getProduct('ProductNo', productBarcode);
      }
      if (!Object.keys(productMasterRes).length > 0) {
        productBarcode = productBarcode.substr(0, productBarcode.length - 1);
        productMasterRes = await getProduct('ProductNo', productBarcode);
      }
      if (!Object.keys(productMasterRes).length > 0) {
        // this.productExtractFailed(record, type);
      } else {
        // if success set ProductBarcode to the trimmed result
        productData = Object.assign(productData, {
          BarcodeType: type,
          ProductNo: productMasterRes.ProductNo,
          ProductDescription: productMasterRes.ProductDescription,
          ProductBarcode: arr[0],
          ProductValid: true,
          ProductEnterType: 'SCAN',
          ScanType: 'product'
        });
      }
      // Find lot
      let lotBarcode = arr[1].trim();
      lotBarcode = `+${lotBarcode}DD`;
      const lotData = {
        key: scanner.key,
        data: lotBarcode
      };

      const lotScanRes = await findLot(lotData, products, allProduct);
      productData = Object.assign(productData, {
        LotNo: lotScanRes.LotNo,
        LotEnterType: lotScanRes.LotEnterType,
        LotBarcode: lotScanRes.LotBarcode,
        ScanType: 'product',
        ExpirationDate: lotScanRes.ExpirationDate !== undefined
          ? lotScanRes.ExpirationDate : expiryDate,
        ExpDateEnterType: 'SCAN',
      });
    } else {
      const prefixNew = barcode.substring(0, 2);
      if (prefixNew === '+B' || prefixNew === '+E' || prefixNew === '+H' || prefixNew === '+M') {
        // Find the last occurrence of the '+' character
        const lastPlusIndex = barcode.lastIndexOf('+');

        // Split the string at the last '+'
        // const firstPart = str.substring(0, lastPlusIndex);
        // const secondPart = str.substring(lastPlusIndex + 1);

        const arrNew = barcode.split('+');
        let productBarcode = arrNew[1];
        productData = Object.assign(productData, {
          ProductBarcode: productBarcode
        });
        productBarcode = productBarcode.substr(4);

        const splitLotBarcode = barcode.split('+');
        expiryDate = splitLotBarcode[2].substr(4, 6);

        let productMasterRes = await getProduct('ProductNo', productBarcode);
        if (!Object.keys(productMasterRes).length > 0) {
          productBarcode = productBarcode.substr(0, productBarcode.length - 1);
          productMasterRes = await getProduct('ProductNo', productBarcode);
        }

        if (!Object.keys(productMasterRes).length > 0) {
          productBarcode = productBarcode.substr(0, productBarcode.length - 1);
          productMasterRes = await getProduct('ProductNo', productBarcode);
        }

        if (!Object.keys(productMasterRes).length > 0) {
          // this.productExtractFailed(record, type);
        } else {
          // if success set ProductBarcode to the trimmed result
          productData = Object.assign(productData, {
            BarcodeType: type,
            ProductNo: productMasterRes.ProductNo,
            ProductDescription: productMasterRes.ProductDescription,
            ProductBarcode: barcode.substring(0, lastPlusIndex),
            ProductValid: true,
            ProductEnterType: 'SCAN',
            ScanType: 'product'
          });
        }

        // Find lot
        let lotBarcode = arrNew[2].trim();
        lotBarcode = `+${lotBarcode}DD`;
        const lotData = {
          key: scanner.key,
          data: lotBarcode
        };
        const lotScanRes = await findLot(lotData, products, allProduct);

        productData = Object.assign(productData, {
          LotNo: lotScanRes.LotNo,
          LotEnterType: lotScanRes.LotEnterType,
          LotBarcode: (prefixNew === '+B' ? lotScanRes.LotBarcode.substr(0, lotScanRes.LotBarcode.length - 2) : lotScanRes.LotBarcode),
          ScanType: 'product',
          ExpirationDate: lotScanRes.ExpirationDate !== undefined
            ? lotScanRes.ExpirationDate : expiryDate,
          ExpDateEnterType: 'SCAN',
        });
      }
    }
    // this.scanType = 'PRODUCT';
    // this.getScanToolbar().down('#scannerSkipLotButton').setDisabled(this.scanType != 'LOT');

    return productData;
  }

  if ((prefix === '+B' || prefix === '+E' || prefix === '+H' || prefix === '+M') && barcode.length < 20) {
    type = 'HBIC 1D';
    let productBarcode = barcode;
    let productData = {};
    productBarcode = productBarcode.substr(5);

    let productMasterRes = await getProduct('ProductNo', productBarcode);
    if (!Object.keys(productMasterRes).length > 0) {
      productBarcode = productBarcode.substr(0, productBarcode.length - 1);
      productMasterRes = await getProduct('ProductNo', productBarcode);
    }

    if (!Object.keys(productMasterRes).length > 0) {
      productBarcode = productBarcode.substr(0, productBarcode.length - 1);
      productMasterRes = await getProduct('ProductNo', productBarcode);
    }

    if (!Object.keys(productMasterRes).length > 0) {
      // this.productExtractFailed(record, type);
    } else {
      // if success set ProductBarcode to the trimmed result
      productData = Object.assign(productData, {
        BarcodeType: type,
        ProductNo: productMasterRes.ProductNo,
        ProductDescription: productMasterRes.ProductDescription,
        ProductBarcode: barcode,
        ProductValid: true,
        ProductEnterType: 'SCAN',
        ScanType: 'product'
      });
    }
    // this.scanType = 'LOT';
    // this.getScanToolbar().down('#scannerSkipLotButton').setDisabled(this.scanType != 'LOT');
    return productData;
  }

  if (barcode.length >= 16) {
    type = 'HBIC 1D 16';
    let productBarcode = barcode;
    let productData = {};
    productBarcode = productBarcode.substring(5, 9)
      + productBarcode.substring(10, 12)
      + productBarcode.substring(13, 16);
    const productMasterRes = await getProduct('ProductNo', productBarcode);
    if (!Object.keys(productMasterRes).length > 0) {
      // this.productExtractFailed(record, type);
    } else {
      productData = Object.assign(productData, {
        BarcodeType: type,
        ProductBarcode: barcode,
        ProductNo: productMasterRes.ProductNo,
        ProductDescription: productMasterRes.ProductDescription,
        ProductValid: true,
        ProductEnterType: 'SCAN',
        ScanType: 'product'
      });
    }
    // this.scanType = 'LOT';
    // this.getScanToolbar().down('#scannerSkipLotButton').setDisabled(this.scanType != 'LOT');
    return productData;
  }

  return { type: 'UNKNOWN' };
  // this.productExtractFailed(record, type);
};

export const findLot = async (lotScanner, products, allProduct) => {
  let lotData = {};
  // const productNo = products[lotScanner.key].ProductNo;
  const productNo = typeof allProduct !== 'undefined' && allProduct.length > 0 ? allProduct[lotScanner.key].ProductNo : '';

  const barcode = lotScanner.data;
  const prefix = barcode.substring(0, 2);
  const fourfix = barcode.substring(0, 4);

  // console.log('prefix');
  // console.log(prefix);
  // console.log('fourfix');
  // console.log(fourfix);

  // console.log('lotScanner');
  // console.log(lotScanner);
  // console.log('products');
  // console.log(products);

  let lotno = null;
  let expiryDate = null;
  if (prefix === '17') {
    lotno = barcode.substr(2);
    if (barcode.substr(8, 2) === '11'
      && barcode.substr(16, 2) === '10'
      && barcode.length > 18) {
      lotno = barcode.substr(18);
      expiryDate = null;
    } else if (barcode.substr(8, 2) === '10' && barcode.length > 10) {
      lotno = barcode.substr(10);
      expiryDate = barcode.substr(2, 6);
    }
  } else if (prefix === '10') {
    lotno = barcode.substr(2);
    expiryDate = null;
  } else if (prefix === '11') {
    lotno = barcode.substr(2);
    lotno = lotno.slice(-6);
    expiryDate = barcode.substr(10, 6);
  } else if (prefix === '+$' && barcode.charAt(2) !== '$') {
    lotno = barcode.substr(2);
    lotno = lotno.substr(0, lotno.length - 2);
    expiryDate = null;
  } else if (prefix === '+$' && fourfix !== '+$$3') {
    lotno = barcode.substr(9);
    if (lotno.substring(lotno.length - 2) === 'DD') {
      lotno = lotno.substr(0, lotno.length - 4);
      expiryDate = barcode.substr(3, 6);
    } else {
      lotno = lotno.substr(0, lotno.length - 2);
      expiryDate = barcode.substr(3, 6);
    }
  } else if (fourfix === '+$$3' && barcode.length === 18 && productNo === '3092040') {
    lotno = barcode.substr(10);
    lotno = lotno.substr(0, lotno.length - 1);
    expiryDate = barcode.substr(4, 6);
  } else if (fourfix === '+$$3') {
    if (barcode.substring(barcode.length - 1) === '$') {
      lotno = barcode.substr(9);
      lotno = lotno.substr(0, lotno.length - 2);
      expiryDate = barcode.substr(3, 6);
    } else {
      const productPrefix = products.substring(0, 2);
      if (productPrefix === '+B') {
        lotno = barcode.substr(9);
        if (lotno.substring(lotno.length - 2) === 'DD') {
          lotno = lotno.substr(0, lotno.length - 4);
          expiryDate = barcode.substr(3, 6);
        } else {
          lotno = barcode.substr(9);
          lotno = lotno.substr(0, lotno.length - 2);
          expiryDate = barcode.substr(3, 6);
        }
      } else if (productPrefix === '+H') {
        lotno = barcode.substr(10);
        if (lotno.substring(lotno.length - 2) === 'DD') {
          lotno = lotno.substr(0, lotno.length - 2);
          expiryDate = barcode.substr(4, 6);
        } else {
          lotno = barcode.substr(9);
          lotno = lotno.substr(0, lotno.length - 2);
          expiryDate = barcode.substr(3, 6);
        }
      } else if (barcode.length === 18) {
        lotno = barcode.substr(9);
        lotno = lotno.substr(0, lotno.length - 2);
        expiryDate = barcode.substr(3, 6);
      } else {
        lotno = barcode.substr(10);
        lotno = lotno.substr(0, lotno.length - 2);
        expiryDate = barcode.substr(4, 6);
      }
    }
  } else if (fourfix === '+$$8') {
    lotno = barcode.substr(12);
    lotno = lotno.substr(0, lotno.length - 2);
    expiryDate = barcode.substr(6, 6);
  } else if (fourfix === '+$$9') {
    lotno = barcode.substr(15);
    lotno = lotno.substr(0, lotno.length - 2);
    expiryDate = barcode.substr(9, 6);
  }

  if (lotno != null) {
    lotData = Object.assign(lotData, {
      LotBarcode: barcode,
      LotNo: lotno,
      ExpirationDate: expiryDate,
      LotEnterType: 'SCAN',
      ExpDateEnterType: 'SCAN',
      ScanType: 'lot'
    });
  }

  return lotData;
};

export const addEditProduct = async (data, products) => {
  if (products.length > 0) {
    // const user = await getUser();
    // const { selectedTeam: { timezone } } = user;
    return await Promise.all(products.map(async (product) => {
      if (!product.hasOwnProperty('CaseProductsID')) {
        // add product
        product.RepCaseNo = data.RepCaseNo;
        product.ProductRep = data.CoverRep;
        // product.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
        product.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
        const addProductRes = await addProduct(product);
        return addProductRes.data;
      }
      // edit product
      const caseProductId = product.CaseProductsID;
      delete product.CaseProductsID;
      // product.ScanDate = moment(moment.tz(
      //   product.ScanDate, 'YYYY-MM-DD HH:mm:ss.SSS', SERVER_TIMEZONE
      // )).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
      product.ScanDate = moment(product.ScanDate).format('YYYY-MM-DD HH:mm:ss.SSS');
      const editProductRes = await updateProduct(caseProductId, product);
      return editProductRes.data;
    }));
  }
};
